// third-party
import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

// project imports
import snackbarReducer from './slices/snackbar';
import customerReducer from './slices/customer';
import contactReducer from './slices/contact';
import productReducer from './slices/product';
import chatReducer from './slices/chat';
import calendarReducer from './slices/calendar';
import mailReducer from './slices/mail';
import userReducer from './slices/user';
import cartReducer from './slices/cart';
import kanbanReducer from './slices/kanban';
import menuReducer from './slices/menu';
import accountReducer from './accountReducer';
import walletReducer from './slices/wallet';
import fileReducer from './slices/file';
import templateReducer from './slices/template';
import purchaseReducer from './slices/purchase';
import storeReducer from './slices/store';

// ==============================|| COMBINE REDUCER ||============================== //

const reducer = combineReducers({
    snackbar: snackbarReducer,
    cart: persistReducer(
        {
            key: 'cart',
            storage,
            keyPrefix: 'teedovey-'
        },
        cartReducer
    ),
    account: persistReducer(
        {
            key: 'account',
            storage,
            keyPrefix: 'teedovey-'
        },
        accountReducer
    ),
    kanban: kanbanReducer,
    customer: customerReducer,
    contact: contactReducer,
    product: persistReducer(
        {
            key: 'product',
            storage,
            keyPrefix: 'teedovey-'
        },
        productReducer
    ),
    chat: chatReducer,
    calendar: calendarReducer,
    mail: mailReducer,
    user: userReducer,
    menu: menuReducer,
    wallet: walletReducer,
    file: fileReducer,
    template: templateReducer,
    purchase: purchaseReducer,
    store: storeReducer
});

export default reducer;
